import styled from "styled-components"
import { GradientText } from "../../../utils"
import { UniversalBannerContent } from "../UniversalBannerContent"

const TextWrapper = styled.span`
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 42px;
  line-height: 150%;
  letter-spacing: 2%;
  vertical-align: middle;
  text-transform: capitalize;

  @media (max-width: 1023px) {
    font-size: 26px;
    letter-spacing: 0%;
  }
  @media (max-width: 600px) {
    font-size: 24px;
  }
`

const StyledGradientTitle = styled(GradientText)`
  ${(props) => props.theme.typography.heroHeadline};
  font-weight: 600;

  @media (max-width: 1023px) {
    font-size: 26px;
  }
  @media (max-width: 600px) {
    font-size: 24px;
  }
`

const GradientTitle = styled.span`
  ${(props) => props.theme.typography.heroHeadline};
  background: ${(props) => props.theme.indicatorGradient};
  background-clip: text;
  font-weight: 600;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 1023px) {
    font-size: 1.625rem;
  }
  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`

const Wrapper = styled.div`
  background: ${(props) => props.theme.coverGradient};
  background-color: ${(props) => props.theme.blue5};
  height: 100vh;
  width: 100%;
  vertical-align: middle;
  display: flex;
  justify-content: center;
`
interface ICommonBannerProps {
  textBeforegradient?: string
  textOnGradient?: string
  textAfterGradient?: string
  content?: string
  bannerImage?: string
  secondTextOnGradient?: string
  textAferSecondGradient?: string
  gradientTitle?: string
}

const CommonBanner: React.FC<ICommonBannerProps> = ({
  textBeforegradient,
  textOnGradient,
  textAfterGradient,
  content,
  bannerImage,
  secondTextOnGradient,
  textAferSecondGradient,
  gradientTitle,
}) => {
  return (
    <Wrapper id={"banner"}>
      <UniversalBannerContent
        title={
          <>
            <>
              <TextWrapper>
                {textBeforegradient}
                <GradientTitle>{gradientTitle}</GradientTitle>
              </TextWrapper>
            </>

            <TextWrapper>
              <StyledGradientTitle>{textOnGradient} </StyledGradientTitle>
              {textAfterGradient}
            </TextWrapper>
            <StyledGradientTitle>{secondTextOnGradient} </StyledGradientTitle>
            {textAferSecondGradient}
          </>
        }
        content={content}
        imagepath={bannerImage}
        iconpath={"/assets/icons/messenger.svg"}
      />
    </Wrapper>
  )
}

export { CommonBanner }
